module.exports = __webpack_public_path__ + "img/bg-header.4661250.png";